import { makeCounter } from '../misc/makeCounter.js';
export const apiCallCounter = makeCounter();
export function getFuncName(fn) {
    return fn.name || null;
}
export function onRequestGlobal(client, promise, apiCall) {
    const onRequest = client?.globalApiCallbacks?.onRequest;
    if (onRequest) {
        const apiCallState = {
            promise,
            clientState: client.getState(),
        };
        const apiCallRequest = {
            ...apiCall,
            ...apiCallState,
        };
        // invoke client.globalApiCallbacks.onRequest if it exists
        onRequest(apiCallRequest);
    }
}
export function onResponseGlobal(client, promise, apiCall, payload, apiError) {
    const onResponse = client?.globalApiCallbacks?.onResponse;
    if (onResponse) {
        const apiCallState = {
            promise,
            clientState: client.getState(),
        };
        const apiCallResponse = {
            ...apiCall,
            ...apiCallState,
            payload,
            apiError,
        };
        // invoke client.globalApiCallbacks.onResponse if it exists
        onResponse(apiCallResponse);
    }
}
/**
  onCallGlobal
  - This handler enables us to have "global" callbacks that get invoked on every
    api call request and response event. This is useful for things like global error handling
    (e.g. if any response returns a 429, trigger a particular UI flow)
  - Usage: createCall.js call object exposes setters to the consuming application:
    call.setOnRequest to set global onRequest callback on the client.globalApiCallbacks object
    call.setOnResponse to set global onResponse callback on the client.globalApiCallbacks object
  - The promise param should be an instance of a promise returned by callWithCallback or callWithPromise
  - Invokes client.globalApiCallbacks.onRequest immediately (if it is defined)
  - Invokes client.globalApiCallbacks.onResponse when the response returns (if it is defined)
 */
export default function onCallGlobal(client, callee, calleeArgs, promise) {
    // functionName example: 'getApiAccount'
    const functionName = getFuncName(callee);
    const apiCallCount = apiCallCounter();
    // apiCallId example: 'getApiAccount-4'
    // apiCallId example if functionName is null (for some reason): '4'
    const apiCallId = [functionName, apiCallCount].join('-');
    const apiCall = {
        functionName,
        functionArgs: calleeArgs,
        apiCallId,
    };
    onRequestGlobal(client, promise, apiCall);
    // Start a new promise chain from the original promise using Promise.race()
    // to ensure we don't interfere with the invoked call's existing promise chain
    return (Promise.race([promise])
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then((payload) => {
        onResponseGlobal(client, promise, apiCall, payload);
    })
        .catch((apiError) => {
        const payload = apiError;
        onResponseGlobal(client, promise, apiCall, payload, apiError);
    }));
}
